<template>
    <div
        class="ribbon-root replacements-merc-ribbon"
        :class="{collapsed: viewMode === 'editor'}"
    >
        <div
            v-if="viewMode !== 'editor'"
            class="ribbon-block">
            <div class="ribbon-select-block slim">
                <div class="ribbon-select">
                    <div class="ribbon-select-label">{{$t('Equipment')}}:</div>
                    <br />
                    <v-select
                            class="ribbon-select-select"
                            v-model="selectedEquipment"
                            :items="equipments"
                            item-value="id"
                            item-text="name"
                            v-on:change="updateEquipment"
                    />
                </div>
            </div>
        </div>
        <div
            v-if="viewMode !== 'editor'"
            class="ribbon-block separator"/>
        <div
            v-if="viewMode !== 'editor'"
            class="ribbon-block">
            <div class="ribbon-block-title">{{$t('View Settings')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button
                    :text="$t('Display Columns')"
                    :image="require('@/assets/icons/toolbar/columns.svg')"
                    :condensed="0"
                    @clicked="showColumnSelection"/>
                <div class="ribbon-button-two-state-box">
                    <ribbon-button-two-state
                        :text="$t('Code Description')"
                        :active="this.selectedCodeTexts"
                        :condensed="1"
                        @clicked="toggleCodeTexts"
                    />
                </div>
            </div>
        </div>
        <div
            v-if="allowed.write && viewMode !== 'editor'"
            class="ribbon-block separator"
        />
        <div v-if="allowed.write || viewMode === 'editor'" class="ribbon-block">
            <div class="ribbon-block-title">{{$t('Actions')}}</div>
            <div class="ribbon-button-bar">
                <ribbon-button
                    v-if="viewMode !== 'editor'"
                    :text="$t('Add a new Replacement')"
                    :image="require('@/assets/icons/toolbar/add.svg')"
                    :condensed="2"
                    @clicked="$emit('addRow')"
                />
                <ribbon-button
                    :text="$t('Save')"
                    :image="require('@/assets/icons/toolbar/save.svg')"
                    :disabled="!savable"
                    :condensed="0"
                    @clicked="$emit('saveData')"/>
                <!--
                <ribbon-button
                    :text="$t('Save and Copy')"
                    :image="require('@/assets/icons/toolbar/import.svg')"
                    :disabled="!savable"
                    :hidden="true"
                    @clicked="$emit('saveAndCopyData')"/>
                    -->
                <ribbon-button
                    v-if="viewMode !== 'editor'"
                    :text="$t('Remove Replacement')"
                    :image="require('@/assets/icons/toolbar/import.svg')"
                    :disabled="!removable"
                    :condensed="2"
                    @clicked="$emit('removeRow')"/>
            </div>
        </div>
        <selector-popup
            v-if="selectorItems"
            :items="selectorItems"
            :items-preselect="selectorItemsSelected"
            :item-text="'title'"
            :item-value="'id'"
            :filter="true"
            :filter-mode="'contains'"
            :multi-select="selectorMultiSelect"
            @itemSelected="handleSelectorSelected"
        />
    </div>

</template>

<script>
    import RibbonButton from "./../../Ribbon/RibbonButton";
    import RibbonButtonTwoState from "./../../Ribbon/RibbonButtonTwoState";
    import SelectorPopup from "../../SelectorPopup";
    import router from "../../../router";
    import authorization from "../../../plugins/authorization";

    export default {
        name: "RibbonReplacementsMerc",
        components: {SelectorPopup, RibbonButton, RibbonButtonTwoState},
        props: {
            viewMode:       String,
            codeTexts:      Boolean,
            columns:        Array,
            savable:        Boolean,
            removable:      Boolean,

            equipment:      String,
            equipments:     Array,
            serviceType:    String,
            serviceTypes:   Array,
            layoutType:     String,
            layoutTypes:    Object,
            layoutValue:    String,

            componentCodes: Object,
            surveyTypes:    Object,
            isoCodes:       Object
        },
        data: function() {
            return {
                selectedEquipment:   this.equipment,
                selectedCodeTexts:   this.codeTexts,

                selectorItems:         null,
                selectorItemsSelected: null,
                selectorMultiSelect:   null,

                allowed: {
                    read:  authorization.isAllowed('Settings/CEDEX Settings/Replacements/MERC'),
                    write: authorization.isAllowed('Settings/CEDEX Settings/Replacements/MERC', authorization.write),
                },
            };
        },
        methods: {
            async updateEquipment() {
                if (await this.$confirmLeaveDialog()) {
                    this.$emit('updateView', 'equipment', this.selectedEquipment)
                } else {
                    this.selectedEquipment = this.equipment;
                }
            },
            showColumnSelection() {
                this.selectorItems = this.columns;
                this.selectorItemsSelected = [];
                for (let columnIndex in this.columns) {
                    if (this.columns[columnIndex].visible) {
                        this.selectorItemsSelected.push(this.columns[columnIndex].id);
                    }
                }
                this.selectorMultiSelect = true;
            },
            handleSelectorSelected(selectedColumns) {
                this.selectorItems = null;
                this.$emit('updateVisibleColumns', selectedColumns);
            },
            toggleCodeTexts() {
                this.selectedCodeTexts = !this.selectedCodeTexts;
                this.$emit('codeTexts', this.selectedCodeTexts);
            },
            async navigate(target) {
                if (await this.$confirmLeaveDialog()) {
                    router.push({name: target});
                }
            }
        }
    }
</script>

<style scoped>
    div.ribbon-root {
        text-align: left;
        height: 104px;
        background-color: var(--toolbar-background);
    }
    div.ribbon-root > div {
        display: inline-block;
    }
    div.ribbon-block {
        margin-left: 8px;
        margin-right: 8px;
        height: 104px;
        vertical-align: top;
    }
    div.ribbon-block.separator {
        background-color: var(--toolbar-separator);
        width: 1px;
        margin: 8px 0;
        height: 88px;
    }
    div.ribbon-block-title {
        font-size: 12px;
        color: var(--toolbar-label);
        text-align: center;
        padding-top: 8px;
    }
    div.ribbon-select-block {
        display: inline-block;
        padding-top: 8px;
    }
    div.ribbon-select-block:not(:last-child) {
        margin-right: 8px
    }

    div.ribbon-select-block.slim div.ribbon-select {
        height: unset;
        overflow: unset;
        padding: 30px 8px 0 8px;
    }

    div.ribbon-select {
        height: 30px;
        overflow: hidden;
    }
    div.ribbon-select > div {display: inline-block}
    div.ribbon-select-label {
        color: var(--toolbar-label);
        display: inline-block;
        width: 120px;
        font-size: 14px;
        height: 30px;
        vertical-align: top;
        line-height: 220%;
    }
    div.ribbon-button-two-state-box {
        display: inline-block;
        width: 136px;
        height: 72px;
        padding: 8px 0;
    }

</style>